import React, { useState } from 'react'
import Carousel, { Modal, ModalGateway } from 'react-images'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  LocationSelect,
  MobileScreen,
} from 'components'
import { headerBg, logo, logoTitle, mobileLogo, viewMenu } from 'images'
import { dispatch } from 'store'

const orderingUrl =
  process.env.REACT_APP_ENVIRONMENT === 'dev'
    ? 'https://demo.codefusion.tech/restaurants/ebisu/locations/ebisuLocation1'
    : 'https://order.codefusion.tech/restaurants/8GFwb8UTNOQ2rbtqc9kk/locations/Y7GXtSFgqD6z5v9Jpd8q'

const images = []

export default () => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <MobileScreen>
        <CFView
          column
          center
          w="100%"
          bg="white"
          boxShadow="0 2px 5px rgba(0,0,0,.5)"
          h="70px"
        >
          <CFView row center>
            <CFImage w="70%" src={mobileLogo} alt="Namiya Sushi Logo" />
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          column
          center
          w="100%"
          h="50px"
          bg="#FFC600"
          boxShadow="0 2px 5px rgba(0,0,0,.5)"
          zIndex={98}
        >
          <CFView row justifyBetween alignCenter w="100%" maxWidth="1400px">
            <CFView row center mt="80px" ml="45px">
              <CFImage
                h="130px"
                src={logo}
                alt="Namiya Sushi Logo"
                zIndex={98}
                pv="5px"
              />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
      <ModalGateway>
        {showModal ? (
          <Modal onClose={() => setShowModal(false)}>
            <Carousel views={images} />
          </Modal>
        ) : null}
      </ModalGateway>
    </>
  )
}
